export function openUrl(url) {
    if (url) {
        // Check if URL already has a protocol
        if (!url.startsWith('http://') && !url.startsWith('https://')) {
            url = 'https://' + url
        }
        window.open(url, '_blank')
    }
}
